import angular from 'angular';
import ResourcesModule from '../resources/resources';
import { difference } from "../common/util/comparison-util";

export default angular.module('app.services.variationRendering', [
  ResourcesModule.name
])
  .service('variationRenderingUtilService', function (allVariationsAndCreativesRetrieved, $stateParams, GamesResource) {
    return {
      creativePropertiesToIgnoreForComparison: ['timestamp', '$$hashKey'],
      variationPropertiesToIgnoreForComparison: ['touched', 'loaded'],
      loadVariation: function(variationTabName, variations, pristineVariations) {
        let decodeCreativeDefinition = (creative) => {
          try {
            creative.definition = creative.definition ? JSON.parse(creative.definition) : null;
          } catch (e) {
            console.log(`error while parsing definition: ${creative.definition}, e: ${e}`);
          } finally {
            creative.timestamp = moment.utc(creative.updated_at);
          }
        };

        if (_.isEmpty(variations) && _.isEmpty(pristineVariations)) {
          return;
        }

        const variationIndex = this.getTabIndexByTabName(variationTabName);
        const variation = variations[variationIndex];
        if (variation.id && !variation.loaded) {
          if (variation.language === null) {
            variation.language = '--';
          }
              GamesResource.one($stateParams.gameId).one('variations', variation.id).getList('creatives', {search_term: $stateParams.searchTerm})
              .then((creatives) => {
                variation.creatives = creatives.plain();
                variation.creatives.forEach(decodeCreativeDefinition);
                pristineVariations[variation.id] = _.cloneDeep(variation);
                allVariationsAndCreativesRetrieved.onNext(pristineVariations);
                variations[variationIndex].loaded = true;
              })
        }
      },
      variationTouchedCheck: function(variationTabName, variations, pristineVariations) {
        if (_.isEmpty(variations) && _.isEmpty(pristineVariations)) {
          return;
        }
        if (!_.isEmpty(variations) && !_.isEmpty(pristineVariations)) {
          const variationIndex = this.getTabIndexByTabName(variationTabName);
          if (!this.isVariationNew(variations, variationIndex)) {
            var pristineVar = pristineVariations[variations[variationIndex].id] || {};
            let cleanedDifference = this.getCleanVariationDifference(variations[variationIndex], pristineVar);
            let isVariationPristine = _.isEqual(variations[variationIndex], pristineVar);
            if (isVariationPristine || _.isEmpty(cleanedDifference)) {
              delete variations[variationIndex].touched;
            } else {
              variations[variationIndex].touched = true;
            }
          }
        }
      },
      getCleanVariationDifference: function(potentiallyModifiedVariation, pristineVariation) {
        let differenceObject = difference(potentiallyModifiedVariation, pristineVariation);
        if(_.isEmpty(differenceObject)) {
          return differenceObject;
        } else {
          differenceObject = _.omit(differenceObject, this.variationPropertiesToIgnoreForComparison);
          _.forEach(differenceObject, (value, name) => {
            if(name === 'creatives') {
              differenceObject[name] = _.map(value, (creative) => {
                return _.omit(creative, this.creativePropertiesToIgnoreForComparison);
              });
              differenceObject[name] = _.map(differenceObject[name], (creative) => {
                return _.isEmpty(creative['companionAdsMap']) ? _.omit(creative, 'companionAdsMap') : creative;
              });
              differenceObject[name] = _.filter(differenceObject[name], function(o) { return !_.isEmpty(o); })
            }
            if(differenceObject[name] && differenceObject[name].length == 0) { delete differenceObject[name]; }
          });
          return differenceObject;
        }
      },
      isVariationNew: function(variations, index) {
        return variations[index].id === undefined;
      },
      getTabIndexByTabName: function(tabName) {
        return parseInt(tabName.split('-')[1] - 1, 10);
      },
      isVariationFormToRender($index, activeTab, variations) {
        return this.getTabIndexByTabName(activeTab) === $index
          || variations[$index].touched
          || variations[$index].id === undefined;
      }
    };
  })



/** WEBPACK FOOTER **
 ** ./src/services/variationsServices.js
 **/